/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Status } from './Status';
// @ts-ignore
import {
// @ts-ignore
    StatusFromJSON,
// @ts-ignore
    StatusFromJSONTyped,
// @ts-ignore
    StatusToJSON,
} from './Status';

/**
 * 
 * @export
 * @interface ProductListRetailerAssignment
 */
export interface ProductListRetailerAssignment {
    /**
     * 
     * @type {string}
     * @memberof ProductListRetailerAssignment
     */
    retailerId: string;
    /**
     * 
     * @type {Status}
     * @memberof ProductListRetailerAssignment
     */
    status: Status;
    /**
     * 
     * @type {Date}
     * @memberof ProductListRetailerAssignment
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductListRetailerAssignment
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ProductListRetailerAssignment interface.
 */
// @ts-ignore
export function instanceOfProductListRetailerAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "retailerId" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

// @ts-ignore
export function ProductListRetailerAssignmentFromJSON(json: any): ProductListRetailerAssignment {
    return ProductListRetailerAssignmentFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductListRetailerAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListRetailerAssignment {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retailerId': json['retailer_id'],
        'status': StatusFromJSON(json['status']),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

// @ts-ignore
export function ProductListRetailerAssignmentToJSON(value?: ProductListRetailerAssignment | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retailer_id': value.retailerId,
        'status': StatusToJSON(value.status),
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

